import React from 'react';

const SubMenuElectro = () => {
    return (
        <>
            <option value="кофемолка">кофемолка</option>
            <option value="Телевизор">Телевизор</option>
            <option value="Блендер">Блендер</option>
            <option value="Утюги">Утюги</option>
            <option value="Колонки">Колонки</option>
            <option value="электро плита">электро плита</option>
            <option value="Фен">Фен</option>
            <option value="Камера">Камера</option>
        </>
    );
};

export default SubMenuElectro;